import { street } from './helper/ValidatorRules'

const streetValidator = {
  getMessage: () => 'Sorry, only letters, numbers (0-9), and symbols (. , - / \') are allowed.',
  validate: value => {
    return {
      valid: street(value),
      data: {
        required: true
      }
    }
  }
}

export default streetValidator
